import React from 'react';

import Section from 'react-scale/components/ui/section';
import SectionTitle from 'react-scale/components/ui/section-title';

import SelfDrivingCarsSliderP1 from 'react-scale/components/website/solutions/self-driving-cars/sliders/p1';
import SelfDrivingCarsSliderP2 from 'react-scale/components/website/solutions/self-driving-cars/sliders/p2';
import SelfDrivingCarsSliderP3 from 'react-scale/components/website/solutions/self-driving-cars/sliders/p3';
import ArSliderP1 from 'react-scale/components/website/solutions/ar/sliders/p1';
import ArSliderP2 from 'react-scale/components/website/solutions/ar/sliders/p2';
import ArSliderP3 from 'react-scale/components/website/solutions/ar/sliders/p3';
import RoboticsSliderP1 from 'react-scale/components/website/solutions/robotics/sliders/p1';
import RoboticsSliderP2 from 'react-scale/components/website/solutions/robotics/sliders/p2Alternative';
import RoboticsSliderP3 from 'react-scale/components/website/solutions/robotics/sliders/p3';

const featuresSlides = [
  {
    img: <SelfDrivingCarsSliderP1 />,
    label: 'Self Driving Cars Pixel Perfection'
  },
  {
    img: <SelfDrivingCarsSliderP2 />,
    label: 'Self Driving Cars Multiple Classes'
  },
  {
    img: <SelfDrivingCarsSliderP3 />,
    label: 'Self Driving Cars Internationally Versatile'
  },
  {
    img: <ArSliderP1 />,
    label: 'Ar/Vr Pixel Perfection'
  },
  {
    img: <ArSliderP2 />,
    label: 'Ar/Vr Multiple Classes'
  },
  {
    img: <ArSliderP3 />,
    label: 'Ar/Vr Multiple Shapes'
  },
  {
    img: <RoboticsSliderP1 />,
    label: 'Robotics Pixel Perfection'
  },
  {
    img: <RoboticsSliderP2 />,
    label: 'Robotics Multiple Classes'
  },
  {
    img: <RoboticsSliderP3 />,
    label: 'Robotics Multiple Shapes'
  }
];

const Features = ({ overtitle, title, subtitle, list, bg }) => (
  <Section bg={bg} className="features" relative>
    <SectionTitle overtitle={overtitle} title={title} subtitle={subtitle} />
    <div className="grid gap-16 lg:grid-cols-3 md:pb-10">
      {list?.map(item => (
        <div key={item.label}>
          <div className="relative w-full bg-white">
            {featuresSlides.filter(each => each.label === item.img)[0]?.img}
          </div>
          <p className="mt-6 text-xl font-aeonik text-neutral-50">{item.label}</p>
        </div>
      ))}
    </div>
  </Section>
);

Features.defaultProps = {
  bg: 'bg-black'
};

export default Features;
